export enum DataObservatoryCatalogAgentAssistantTools {
  FilterDatasets = 'filter_datasets',
  SearchVariables = 'search_variables'
}
